module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', [_c('el-form', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单号:",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.query.OrderCode),
      callback: function($$v) {
        _vm.$set(_vm.query, "OrderCode", $$v)
      },
      expression: "query.OrderCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "园所名称:"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "-请选择-"
    },
    on: {
      "change": _vm.chooseSchool
    },
    model: {
      value: (_vm.query.SchoolId),
      callback: function($$v) {
        _vm.$set(_vm.query, "SchoolId", $$v)
      },
      expression: "query.SchoolId"
    }
  }, _vm._l((_vm.schoolList), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.Id,
        "label": option.SchoolName
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "班级:"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "-请选择-"
    },
    model: {
      value: (_vm.query.ClassId),
      callback: function($$v) {
        _vm.$set(_vm.query, "ClassId", $$v)
      },
      expression: "query.ClassId"
    }
  }, _vm._l((_vm.classList), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.ClassId,
        "label": option.ClassName
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "下单人:",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.query.SalesMan),
      callback: function($$v) {
        _vm.$set(_vm.query, "SalesMan", $$v)
      },
      expression: "query.SalesMan"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "跟进人:",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.query.FollowEmployeeName),
      callback: function($$v) {
        _vm.$set(_vm.query, "FollowEmployeeName", $$v)
      },
      expression: "query.FollowEmployeeName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "园长:",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.query.PrincipalName),
      callback: function($$v) {
        _vm.$set(_vm.query, "PrincipalName", $$v)
      },
      expression: "query.PrincipalName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "园长电话:",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.query.PrincipalTel),
      callback: function($$v) {
        _vm.$set(_vm.query, "PrincipalTel", $$v)
      },
      expression: "query.PrincipalTel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAllData),
      expression: "isAllData"
    }],
    attrs: {
      "label": "任务状态:"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "-请选择-"
    },
    model: {
      value: (_vm.query.CheckStatus),
      callback: function($$v) {
        _vm.$set(_vm.query, "CheckStatus", $$v)
      },
      expression: "query.CheckStatus"
    }
  }, _vm._l((_vm.OptionTypes), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.id,
        "label": option.name
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "跟进状态:"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "-请选择-"
    },
    model: {
      value: (_vm.query.FollowStatus),
      callback: function($$v) {
        _vm.$set(_vm.query, "FollowStatus", $$v)
      },
      expression: "query.FollowStatus"
    }
  }, _vm._l((_vm.FollowTypes), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.Id,
        "label": option.OptionTitle
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.query.CheckStatus !== 1 && this.$route.path !== '/Network/networkDevice'),
      expression: "query.CheckStatus!==1&&this.$route.path !== '/Network/networkDevice'"
    }],
    attrs: {
      "label": "是否需要上门服务:"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "-请选择-"
    },
    model: {
      value: (_vm.query.IT_Service),
      callback: function($$v) {
        _vm.$set(_vm.query, "IT_Service", $$v)
      },
      expression: "query.IT_Service"
    }
  }, _vm._l((_vm.ITServiceTypes), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.Id,
        "label": option.name
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发货时间:"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.query.StockOutStartTime),
      callback: function($$v) {
        _vm.$set(_vm.query, "StockOutStartTime", $$v)
      },
      expression: "query.StockOutStartTime"
    }
  }), _vm._v(" "), _c('span', [_vm._v("到")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.query.StockOutEndTime),
      callback: function($$v) {
        _vm.$set(_vm.query, "StockOutEndTime", $$v)
      },
      expression: "query.StockOutEndTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "跟进时间:"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.query.FollowStartTime),
      callback: function($$v) {
        _vm.$set(_vm.query, "FollowStartTime", $$v)
      },
      expression: "query.FollowStartTime"
    }
  }), _vm._v(" "), _c('span', [_vm._v("到")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.query.FollowEndTime),
      callback: function($$v) {
        _vm.$set(_vm.query, "FollowEndTime", $$v)
      },
      expression: "query.FollowEndTime"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "search"
    },
    on: {
      "click": _vm.onQuerySubmit
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "delete2"
    },
    on: {
      "click": _vm.onQueryClean
    }
  }, [_vm._v("重置")])], 1), _vm._v(" "), _c('div', {
    staticClass: "toolbar",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n\t\t\t汇总：待收货设备安装" + _vm._s(_vm.totalData.DeviceInstall) + "条，待网络检测" + _vm._s(_vm.totalData.NetCheck) + "条\n\t\t")]), _vm._v(" "), _c('div', [_c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAllData),
      expression: "isAllData"
    }, {
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.lists,
      "element-loading-text": "拼命加载中",
      "border": "",
      "router": ""
    },
    on: {
      "sort-change": _vm.sortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "ID",
      "prop": "Id",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单号",
      "prop": "OrderCode",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "项目类型",
      "prop": "ProjectTypeName",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "套餐名称",
      "prop": "PackageName",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "园所名称",
      "prop": "SchoolName",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "班级",
      "prop": "ClassName",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.ClassName !== '') ? _c('span', [_vm._v(_vm._s(scope.row.ClassName))]) : _c('span', [_vm._v("--")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "下单人",
      "prop": "BusEmployeeName",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "园长",
      "prop": "PrincipalName",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "园长电话",
      "prop": "PrincipalPhoneNo",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "任务状态",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.CheckStatusName))]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.IT_ServiceName !== '' && scope.row.CheckStatus == 2),
            expression: "scope.row.IT_ServiceName!==''&&scope.row.CheckStatus==2"
          }]
        }, [_vm._v("(" + _vm._s(scope.row.IT_ServiceName) + ")")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "发货时间",
      "prop": "StockOutTime",
      "sortable": "custom",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "跟进人",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.ModifyFollowRole !== 1) ? _c('span', [_vm._v(_vm._s(scope.row.FollowEmployeeName))]) : _c('el-dropdown', {
          attrs: {
            "trigger": "click",
            "placement": "bottom-start"
          },
          on: {
            "command": _vm.handleCommand
          }
        }, [_c('span', {
          staticClass: "el-dropdown-link"
        }, [_c('el-button', {
          staticStyle: {
            "color": "#1f2d3d"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.changeFllow(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.FollowEmployeeName) + "\n\t\t\t\t\t\t\t\t\t"), _c('i', {
          staticClass: "fa fa-chevron-circle-down"
        })])], 1), _vm._v(" "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, _vm._l((_vm.dropDowns), function(item, index) {
          return _c('el-dropdown-item', {
            attrs: {
              "command": item.Id.toString()
            }
          }, [_vm._v(_vm._s(item.EmployeeName))])
        }))], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "跟进时间",
      "prop": "FolllowTime",
      "sortable": "custom",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "跟进状态",
      "prop": "FollowScheduleName",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "width": "120",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "success"
          },
          on: {
            "click": function($event) {
              _vm.handleView(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isAllData),
      expression: "!isAllData"
    }, {
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.lists,
      "element-loading-text": "拼命加载中",
      "border": "",
      "router": ""
    },
    on: {
      "sort-change": _vm.sortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "ID",
      "prop": "Id",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单号",
      "prop": "OrderCode",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "项目类型",
      "prop": "ProjectTypeName",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "套餐名称",
      "prop": "PackageName",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "园所名称",
      "prop": "SchoolName",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "监测对象",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.BabyId > 0) ? _c('span', [_vm._v(_vm._s(scope.row.BabyName))]) : _c('span', [_vm._v(_vm._s(scope.row.ClassName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "下单人",
      "prop": "BusEmployeeName",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "园长",
      "prop": "PrincipalName",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "园长电话",
      "prop": "PrincipalPhoneNo",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "任务状态",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.CheckStatusName))]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.IT_ServiceName !== '' && scope.row.CheckStatus == 2),
            expression: "scope.row.IT_ServiceName!==''&&scope.row.CheckStatus==2"
          }]
        }, [_vm._v("(" + _vm._s(scope.row.IT_ServiceName) + ")")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "发货时间",
      "prop": "StockOutTime",
      "sortable": "custom",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "跟进人",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.ModifyFollowRole !== 1) ? _c('span', [_vm._v(_vm._s(scope.row.FollowEmployeeName))]) : _c('el-dropdown', {
          attrs: {
            "trigger": "click",
            "placement": "bottom-start"
          },
          on: {
            "command": _vm.handleCommand
          }
        }, [_c('span', {
          staticClass: "el-dropdown-link"
        }, [_c('el-button', {
          staticStyle: {
            "color": "#1f2d3d"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.changeFllow(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.FollowEmployeeName) + "\n\t\t\t\t\t\t\t\t\t"), _c('i', {
          staticClass: "fa fa-chevron-circle-down"
        })])], 1), _vm._v(" "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, _vm._l((_vm.dropDowns), function(item, index) {
          return _c('el-dropdown-item', {
            attrs: {
              "command": item.Id.toString()
            }
          }, [_vm._v(_vm._s(item.EmployeeName))])
        }))], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "跟进时间",
      "prop": "FolllowTime",
      "sortable": "custom",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "跟进状态",
      "prop": "FollowScheduleName",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "width": "330",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "success"
          },
          on: {
            "click": function($event) {
              _vm.handleView(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看")]), _vm._v(" "), _c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.CheckStatus == 2),
            expression: "scope.row.CheckStatus==2"
          }],
          attrs: {
            "size": "small",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              _vm.handleReturn(scope.row)
            }
          }
        }, [_vm._v("回退")]), _vm._v(" "), _c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.isAllData),
            expression: "!isAllData"
          }],
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.handleFllow(scope.$index, scope.row)
            }
          }
        }, [_vm._v("跟进")]), _vm._v(" "), (scope.row.CheckStatus == 1 && !_vm.isAllData) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("完成设备安装下推网络检测")]) : (scope.row.CheckStatus == 2 && !_vm.isAllData) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.handleEdit2(scope.$index, scope.row)
            }
          }
        }, [_vm._v("完成网络检测")]) : _vm._e()]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "btm-action",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.pageIndex,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalSize * 1
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('networkModalDialog', {
    ref: "refsModalDialog",
    on: {
      "reloadList": function($event) {
        _vm.getList()
      }
    }
  }), _vm._v(" "), _c('completeDialog', {
    ref: "refsCompleteDialog",
    on: {
      "reloadList": function($event) {
        _vm.getList()
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3435c26e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Network/networkCheck/index.vue
// module id = 1444
// module chunks = 1